
import { Link } from "react-router-dom";
import SignUpForm from "@/components/auth/SignUpForm";
import { useEffect } from "react";

const SignUp = () => {
  useEffect(() => {
    document.title = "Join EMU | EMU Mentoring";
  }, []);

  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2 overflow-hidden">
      
      {/* Left panel (fixed) */}
      <aside className="hidden lg:block sticky top-0 h-screen bg-[#003BA3]">
        <div className="h-full flex items-center justify-center">
          <div className="w-[614px] h-[614px] max-w-none">
            <img
              src="/lovable-uploads/6345f7f9-e1bc-456f-b3b1-96690802a8b0.png"
              alt="EMU Logo"
              width={614}
              height={614}
              className="w-[614px] h-[614px] object-contain max-w-none"
              loading="eager"
            />
          </div>
        </div>
      </aside>

      {/* Right panel (scrollable) */}
      <main className="h-screen overflow-y-auto">
        <div className="mx-auto w-full max-w-[560px] px-4 xs:px-6 py-8 xs:py-12">
          <div className="flex flex-col xs:flex-row xs:justify-between xs:items-center mb-6 xs:mb-8 space-y-2 xs:space-y-0">
            <h1 className="text-lg xs:text-xl sm:text-2xl font-semibold tracking-tight">Join as a Mentor or Mentee</h1>
            <div className="text-xs xs:text-sm text-gray-500">
              or <Link to="/login" className="text-emu-blue font-medium">sign in</Link>
            </div>
          </div>
          
          <SignUpForm />
          
          {/* Return to home link */}
          <div className="mt-6 xs:mt-8 text-center">
            <Link to="/" className="text-xs xs:text-sm text-emu-blue hover:underline">
              ← Return to Home
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SignUp;
